import { render } from "./SignUpPage.vue?vue&type=template&id=208c3ad4&scoped=true&ts=true&lang=true"
import script from "./SignUpPage.vue?vue&type=script&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&lang=ts"

import "./SignUpPage.vue?vue&type=style&index=0&id=208c3ad4&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208c3ad4"]])

export default __exports__